module.exports = __webpack_public_path__ + "img/logo_golf.b93165bf.svg";